import { useCallback } from 'react';
import { type OnRowClick } from '@optimization/ssi-common';
import { type VehicleRowItem } from '../VehicleList';
import { type UpdateQueryParameterValues } from './use-update-query-parameter-values';

interface UseOpenVehicleDetailProperties {
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const useOpenVehicleDetail = ({
  updateQueryParameterValues,
}: UseOpenVehicleDetailProperties): OnRowClick<VehicleRowItem> => {
  return useCallback(
    ({ row }) => {
      updateQueryParameterValues({
        filterKeys: { chassisNumber: [row.vehicle.chassisNumber] },
      });
    },
    [updateQueryParameterValues],
  );
};

export default useOpenVehicleDetail;
